var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgManualNavLinkIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.666 13.3337H13.3327V10.667H10.666V13.3337ZM10.666 9.33366H13.3327V6.66699H10.666V9.33366ZM6.66602 5.33366H9.33268V2.66699H6.66602V5.33366ZM10.666 5.33366H13.3327V2.66699H10.666V5.33366ZM6.66602 9.33366H9.33268V6.66699H6.66602V9.33366ZM2.66602 9.33366H5.33268V6.66699H2.66602V9.33366ZM2.66602 13.3337H5.33268V10.667H2.66602V13.3337ZM6.66602 13.3337H9.33268V10.667H6.66602V13.3337ZM2.66602 5.33366H5.33268V2.66699H2.66602V5.33366Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManualNavLinkIcon);
export default __webpack_public_path__ + "static/media/manualNavLinkIcon.16e83ef0d01d8596bf8610334d7dd4a7.svg";
export { ForwardRef as ReactComponent };